var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"o-fair__detail o-pastfair__detail"},[_c('h1',[_vm._v(_vm._s(_vm.fair.displayName))]),_vm._l((_vm.booths),function(booth){return _c('div',[_c('h2',[_vm._v(_vm._s(booth.halleBezeichnung)+" / "+_vm._s(booth.standnummer))]),(
        booth.regiNr &&
        _vm.boothDocuments(booth) !== undefined &&
          _vm.boothDocuments(booth).length > 0
      )?_c('rubin-document-listing',{attrs:{"documents":_vm.boothDocuments(booth)}}):_c('div',[_vm._v("\n      "+_vm._s(_vm.$t('components.documentListing.list.nodocuments'))+"\n    ")])],1)})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }